(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autos--hero"] && !Shopify.designMode) return;
  try {
    
  const autosHeroWrappers = document.querySelectorAll('[data-brand-model]');

  autosHeroWrappers.forEach((wrapper) => {
    const brandSelect = wrapper.querySelector('[data-brand-select]');
    const modelSelect = wrapper.querySelector('[data-model-select]');
    const searchButton = wrapper.querySelector('[data-search-button]');
    if (!brandSelect || !modelSelect) return;

    let pairs = [];
    try {
      pairs = JSON.parse(wrapper.dataset.brandModelPairs || '[]');
    } catch (error) {
      pairs = [];
    }

    const modelMap = pairs.reduce((acc, pair) => {
      if (!pair || !pair.brand || !pair.model || !pair.url) return acc;
      if (!acc[pair.brand]) acc[pair.brand] = [];
      acc[pair.brand].push({ label: pair.model, url: pair.url });
      return acc;
    }, {});

    const placeholder = modelSelect.dataset.placeholder || '';

    const resetModels = () => {
      modelSelect.innerHTML = '';
      const option = document.createElement('option');
      option.value = '';
      option.textContent = placeholder;
      option.disabled = true;
      option.selected = true;
      modelSelect.appendChild(option);
      modelSelect.disabled = true;
      modelSelect.classList.add('text-primary/30');
      if (searchButton) searchButton.disabled = true;
    };

    const populateModels = (brand) => {
      resetModels();
      if (!brand || !modelMap[brand]) return;
      modelMap[brand].forEach((model) => {
        const option = document.createElement('option');
        option.value = model.label;
        option.textContent = model.label;
        option.dataset.url = model.url;
        modelSelect.appendChild(option);
      });
      modelSelect.disabled = false;
      modelSelect.classList.remove('text-primary/30');
    };

    resetModels();
    brandSelect.addEventListener('change', (event) => {
      populateModels(event.target.value);
    });
    modelSelect.addEventListener('change', (event) => {
      const selectedOption = event.target.selectedOptions[0];
      const targetUrl = selectedOption?.dataset?.url;
      if (!searchButton) return;
      if (targetUrl) {
        searchButton.disabled = false;
        searchButton.dataset.targetUrl = targetUrl;
      } else {
        searchButton.disabled = true;
      }
    });
    if (searchButton) {
      searchButton.addEventListener('click', () => {
        const targetUrl = searchButton.dataset.targetUrl;
        if (targetUrl) window.location.href = targetUrl;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s--blog-feed"] && !Shopify.designMode) return;
  try {
    
  class BlogFeed {
    constructor(section) {
      this.section = section;
      this.sectionId = section.dataset.sectionId;
      this.searchUrl = section.dataset.searchUrl || '/search';
      this.blogUrl = section.dataset.blogUrl || window.location.pathname;
      this.perPage = Number(section.dataset.articlesPerPage || 12);
      this.allArticles = [];
      this.results = section.querySelector('[data-blog-results]');
      this.pagination = section.querySelector('[data-blog-pagination]');
      this.sentinel = section.querySelector('[data-blog-sentinel]');
      this.searchForm = section.querySelector('[data-blog-search]');
      this.tags = section.querySelector('[data-blog-tags]');
      this.searchInput = section.querySelector('[data-blog-search-input]');
      this.searchWrapper = section.querySelector('[data-blog-search-wrapper]');
      this.searchResults = section.querySelector('[data-blog-search-results]');
      this.searchList = section.querySelector('[data-blog-search-list]');
      this.iconChevronL = section.querySelector('[data-icon-chevron-l]');
      this.iconChevronR = section.querySelector('[data-icon-chevron-r]');
      this.tagLinks = section.querySelectorAll('[data-tag-link]');
      this.isLoading = false;
      this.searchTimeout = null;
      this.currentSearchQuery = '';
      this.currentTag = '';

      this.onTagClick = this.onTagClick.bind(this);
      this.onSearchSubmit = this.onSearchSubmit.bind(this);
      this.onPopState = this.onPopState.bind(this);

      this.initArticles();
      this.initFromUrl();
      this.bindEvents();
      this.setupObserver();
    }

    initArticles() {
      try {
        const raw = this.section.dataset.articlesJson || '[]';
        this.allArticles = JSON.parse(raw);
      } catch (error) {
        this.allArticles = [];
      }
    }

    initFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const query = (params.get('q') || '').trim();
      const tag = (params.get('tag') || '').trim();
      if (!query) return;
      this.currentSearchQuery = query;
      this.currentTag = tag;
      this.applyLocalSearch(1);
    }
    bindEvents() {
      this.tagLinks.forEach((link) => link.addEventListener('click', this.onTagClick));
      if (this.searchForm) {
        this.searchForm.addEventListener('submit', this.onSearchSubmit);
      }
      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => this.onSearchInput());
        this.searchInput.addEventListener('focus', () => this.onSearchInput());
        this.searchInput.addEventListener('blur', () => {
          setTimeout(() => this.hideSearchResults(), 150);
        });
      }
      document.addEventListener('click', (event) => {
        if (!this.searchWrapper) return;
        if (!this.searchWrapper.contains(event.target)) {
          this.hideSearchResults();
        }
      });
      window.addEventListener('popstate', this.onPopState);
    }

    setupObserver() {
      if (!this.sentinel) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadNextPage();
          }
        });
      }, { rootMargin: '200px' });
      this.observer.observe(this.sentinel);
    }

    async loadNextPage() {
      if (this.isLoading || !this.sentinel) return;
      const nextUrl = this.sentinel.dataset.nextUrl;
      if (!nextUrl) return;
      await this.fetchAndUpdate(nextUrl, { append: true, pushState: false });
    }

    onTagClick(event) {
      event.preventDefault();
      const link = event.currentTarget;
      const tagValue = link.dataset.tagValue || '';
      if (this.currentSearchQuery) {
        this.currentTag = tagValue;
        this.applyLocalSearch(1);
        const url = tagValue
          ? `${this.blogUrl}?q=${encodeURIComponent(this.currentSearchQuery)}&tag=${encodeURIComponent(tagValue)}`
          : `${this.blogUrl}?q=${encodeURIComponent(this.currentSearchQuery)}`;
        window.history.pushState({}, '', url);
        return;
      }
      const url = link.getAttribute('href');
      if (!url) return;
      this.fetchAndUpdate(url, { append: false, pushState: true });
    }

    onSearchSubmit(event) {
      event.preventDefault();
      const input = this.searchForm.querySelector('input[name="q"]');
      if (!input) return;
      const query = input.value.trim();
      this.currentSearchQuery = query;
      this.currentTag = '';
      this.applyLocalSearch(1);
      const pushUrl = query ? `${this.blogUrl}?q=${encodeURIComponent(query)}` : this.blogUrl;
      window.history.pushState({}, '', pushUrl);
    }

    onSearchInput() {
      if (!this.searchInput || !this.searchList || !this.searchResults) return;
      const query = this.searchInput.value.trim();
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        if (!query) {
          this.hideSearchResults();
          return;
        }
        this.fetchSearchResults(query);
      }, 200);
    }

    async fetchSearchResults(query) {
      if (!this.searchList || !this.searchResults) return;
      try {
        const url = new URL(this.searchUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'article');
        url.searchParams.set('section_id', 'api--blog-search');
        const response = await fetch(url.toString());
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('.api-blog-search');
        if (!content) {
          this.hideSearchResults();
          return;
        }
        this.searchList.innerHTML = content.innerHTML;
        this.showSearchResults();
      } catch (error) {
        console.error('BlogFeed: failed to fetch search results', error);
        this.hideSearchResults();
      }
    }

    showSearchResults() {
      if (this.searchResults) {
        this.searchResults.classList.remove('hidden');
      }
    }

    hideSearchResults() {
      if (this.searchResults) {
        this.searchResults.classList.add('hidden');
      }
    }

    onPopState() {
      const params = new URLSearchParams(window.location.search);
      const query = (params.get('q') || '').trim();
      const tag = (params.get('tag') || '').trim();
      if (query) {
        this.currentSearchQuery = query;
        this.currentTag = tag;
        this.applyLocalSearch(1);
        return;
      }
      this.currentSearchQuery = '';
      this.currentTag = '';
      this.fetchAndUpdate(this.blogUrl, { append: false, pushState: false });
    }

    applyLocalSearch(page) {
      if (!this.results || !this.pagination) return;
      const query = (this.currentSearchQuery || '').toLowerCase();
      const tag = (this.currentTag || '').toLowerCase();
      const filtered = this.allArticles.filter((item) => {
        if (!item || !item.search) return false;
        if (query && !item.search.includes(query)) return false;
        if (tag) {
          const tags = (item.tags || []).map((value) => String(value).toLowerCase());
          if (!tags.includes(tag)) return false;
        }
        return true;
      });

      const totalPages = Math.max(1, Math.ceil(filtered.length / this.perPage));
      const currentPage = Math.min(Math.max(page, 1), totalPages);
      const start = (currentPage - 1) * this.perPage;
      const pageItems = filtered.slice(start, start + this.perPage);

      this.results.innerHTML = pageItems.map((item) => item.html).join('');
      this.renderLocalPagination(currentPage, totalPages);
      this.renderLocalTags(filtered);
      if (this.sentinel) {
        this.sentinel.removeAttribute('data-next-url');
      }
    }

    renderLocalPagination(currentPage, totalPages) {
      const chevronL = this.iconChevronL ? this.iconChevronL.innerHTML : '';
      const chevronR = this.iconChevronR ? this.iconChevronR.innerHTML : '';
      const prevDisabled = currentPage <= 1;
      const nextDisabled = currentPage >= totalPages;
      const parts = Array.from({ length: totalPages }, (_, idx) => idx + 1);
      this.pagination.innerHTML = `
        <div class="flex items-center justify-between text-ui-base text-primary">
          ${
            prevDisabled
              ? `<span class="flex items-center gap-x-b-sm text-secondary">
                  <span class="w-6 h-6 inline-flex items-center justify-center">${chevronL}</span>
                  <span>Previous</span>
                </span>`
              : `<button type="button" data-local-page="${currentPage - 1}" class="flex items-center gap-x-b-sm">
                  <span class="w-6 h-6 inline-flex items-center justify-center">${chevronL}</span>
                  <span>Previous</span>
                </button>`
          }
          <div class="flex items-center gap-x-b-sm">
            ${parts
              .map((page, index) => {
                const sep = index === 0 ? '' : '<span>/</span>';
                const label = page === currentPage ? `<span class="font-medium">${page}</span>` : `<button type="button" data-local-page="${page}" class="text-ui-base">${page}</button>`;
                return `${sep}${label}`;
              })
              .join('')}
          </div>
          ${
            nextDisabled
              ? `<span class="flex items-center gap-x-b-sm text-secondary">
                  <span>Next</span>
                  <span class="w-6 h-6 inline-flex items-center justify-center">${chevronR}</span>
                </span>`
              : `<button type="button" data-local-page="${currentPage + 1}" class="flex items-center gap-x-b-sm">
                  <span>Next</span>
                  <span class="w-6 h-6 inline-flex items-center justify-center">${chevronR}</span>
                </button>`
          }
        </div>
      `;
      this.pagination.querySelectorAll('[data-local-page]').forEach((button) => {
        button.addEventListener('click', (event) => {
          const page = Number(event.currentTarget.dataset.localPage || 1);
          this.applyLocalSearch(page);
        });
      });
    }

    renderLocalTags(items) {
      if (!this.tags) return;
      const tagSet = new Set();
      items.forEach((item) => {
        (item.tags || []).forEach((tag) => tagSet.add(tag));
      });
      const tags = Array.from(tagSet);
      const allActive = !this.currentTag;
      const tagButtons = tags
        .map((tag) => {
          const active = this.currentTag && String(tag).toLowerCase() === this.currentTag.toLowerCase();
          const classes = active
            ? 'rounded-full px-b-base py-b-xs h5 font-normal border border-secondary color-schema-contrast bg-surface border-contrast'
            : 'rounded-full px-b-base py-b-xs h5 font-normal border border-secondary text-primary';
          return `<button type="button" class="${classes}" data-tag-link data-tag-value="${String(tag).replace(/"/g, '&quot;')}">${tag}</button>`;
        })
        .join('');
      this.tags.innerHTML = `
        <div class="w-full overflow-x-auto" data-tag-scroll>
          <div class="flex items-center gap-x-b-base whitespace-nowrap min-w-full justify-center lg:justify-start">
            <button type="button" class="${allActive ? 'rounded-full px-b-base py-b-xs h5 border border-secondary color-schema-contrast bg-surface border-contrast' : 'rounded-full px-b-base py-b-xs h5 border border-secondary text-primary'}" data-tag-link data-tag-value="">
              ${this.section.querySelector('[data-tag-link]')?.textContent?.trim() || 'See all'}
            </button>
            ${tagButtons}
          </div>
        </div>
      `;
      this.tagLinks = this.tags.querySelectorAll('[data-tag-link]');
      this.tagLinks.forEach((link) => link.addEventListener('click', this.onTagClick));
      const tagRow = this.tags.querySelector('[data-tag-scroll]');
      if (tagRow) {
        const isScrollable = tagRow.scrollWidth > tagRow.clientWidth + 1;
        tagRow.classList.toggle('is-scrollable', isScrollable);
        const tagContent = tagRow.firstElementChild;
        if (tagContent) {
          tagContent.classList.toggle('justify-center', !isScrollable);
          tagContent.classList.toggle('justify-start', isScrollable);
        }
      }
    }


    buildSectionUrl(url, sectionId = this.sectionId) {
      const hasQuery = url.includes('?');
      const joiner = hasQuery ? '&' : '?';
      return `${url}${joiner}section_id=${sectionId}`;
    }

    async fetchAndUpdate(url, { append, pushState, sectionId, pushUrl } = {}) {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        const response = await fetch(this.buildSectionUrl(url, sectionId));
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = doc.querySelector('[data-blog-feed]');
        if (!nextSection) return;

        const nextResults = nextSection.querySelector('[data-blog-results]');
        const nextPagination = nextSection.querySelector('[data-blog-pagination]');
        const nextSentinel = nextSection.querySelector('[data-blog-sentinel]');
        const nextTags = nextSection.querySelector('[data-blog-tags]');

        if (append && nextResults && this.results) {
          Array.from(nextResults.children).forEach((child) => {
            this.results.appendChild(child);
          });
        } else if (nextResults && this.results) {
          this.results.innerHTML = nextResults.innerHTML;
        }

        if (nextPagination && this.pagination) {
          this.pagination.innerHTML = nextPagination.innerHTML;
        }
        if (nextTags && this.tags) {
          this.tags.innerHTML = nextTags.innerHTML;
          this.tagLinks = this.tags.querySelectorAll('[data-tag-link]');
          this.tagLinks.forEach((link) => link.addEventListener('click', this.onTagClick));
        }

        if (this.sentinel) {
          if (nextSentinel && nextSentinel.dataset.nextUrl) {
            this.sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
          } else {
            this.sentinel.removeAttribute('data-next-url');
          }
        } else if (nextSentinel) {
          this.sentinel = nextSentinel;
          this.section.appendChild(this.sentinel);
          this.setupObserver();
        }

        if (pushState) {
          window.history.pushState({}, '', pushUrl || url);
        }
      } catch (error) {
        console.error('BlogFeed: failed to update feed', error);
      } finally {
        this.isLoading = false;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const updateTagScroll = (section) => {
      const tagRow = section.querySelector('[data-tag-scroll]');
      if (!tagRow) return;
      const isScrollable = tagRow.scrollWidth > tagRow.clientWidth + 1;
      tagRow.classList.toggle('is-scrollable', isScrollable);
      const tagContent = tagRow.firstElementChild;
      if (tagContent) {
        tagContent.classList.toggle('justify-center', !isScrollable);
        tagContent.classList.toggle('justify-start', isScrollable);
      }
    };

    document.querySelectorAll('[data-blog-feed]').forEach((section) => {
      if (!section.dataset.bound) {
        section.dataset.bound = 'true';
        new BlogFeed(section);
      }
      updateTagScroll(section);
    });
    window.addEventListener('resize', () => {
      document.querySelectorAll('[data-blog-feed]').forEach(updateTagScroll);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s--car-brand-search"] && !Shopify.designMode) return;
  try {
    
  const brandSearchInputs = document.querySelectorAll('[data-search-input]');

  brandSearchInputs.forEach((input) => {
    const wrapper = input.closest('section');
    const button = wrapper?.querySelector('[data-search-button]');
    const seriesGroups = wrapper?.querySelectorAll('[data-series-group]');
    if (!wrapper || !button || !seriesGroups) return;

    const applyFilter = (value) => {
      const normalized = value.trim().toLowerCase();
      let anyVisible = false;
      seriesGroups.forEach((group) => {
        const seriesTitle = group.dataset.seriesTitle || '';
        const seriesSearch = group.dataset.seriesSearch || '';
        const items = group.querySelectorAll('[data-series-item]');
        let hasVisibleItems = false;

        if (normalized === '') {
          items.forEach((item) => item.classList.remove('hidden'));
          hasVisibleItems = items.length > 0;
        } else if (seriesTitle.includes(normalized)) {
          items.forEach((item) => item.classList.remove('hidden'));
          hasVisibleItems = items.length > 0;
        } else if (seriesSearch.includes(normalized)) {
          items.forEach((item) => {
            const itemSearch = item.dataset.seriesItemSearch || '';
            const matches = itemSearch.includes(normalized);
            item.classList.toggle('hidden', !matches);
            if (matches) hasVisibleItems = true;
          });
        } else {
          items.forEach((item) => item.classList.add('hidden'));
          hasVisibleItems = false;
        }

        group.classList.toggle('hidden', !hasVisibleItems);
        if (hasVisibleItems) anyVisible = true;
      });
      button.disabled = !anyVisible;
    };

    input.addEventListener('input', () => {
      applyFilter(input.value);
    });
    input.addEventListener('change', () => {
      applyFilter(input.value);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      applyFilter(input.value);
    });
    button.addEventListener('click', () => {
      applyFilter(input.value);
    });

    applyFilter('');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s--resources-list"] && !Shopify.designMode) return;
  try {
    
  const resourcesLists = document.querySelectorAll('[data-resources-list]');

  resourcesLists.forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[data-resources-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-resources-panel]'));
    if (!tabs.length || !panels.length) return;

    const setActive = (index) => {
      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('opacity-30', !isActive);
        tab.classList.toggle('underline', isActive);
        tab.classList.toggle('underline-offset-8', isActive);
        tab.classList.toggle('decoration-1', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel, panelIndex) => {
        panel.classList.toggle('hidden', panelIndex !== index);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setActive(index));
    });

    const loadMorePages = async () => {
      if (section.dataset.resourcesLoaded === 'true') return;
      section.dataset.resourcesLoaded = 'true';
      const sectionId = section.dataset.sectionId;
      if (!sectionId) return;

      for (let page = 2; page <= 5; page += 1) {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('page', String(page));
        try {
          const response = await fetch(url.toString());
          if (!response.ok) continue;
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const incomingPanels = doc.querySelectorAll('[data-resources-panel]');
          incomingPanels.forEach((incomingPanel) => {
            const panelIndex = incomingPanel.dataset.panelIndex;
            if (!panelIndex) return;
            const targetPanel = section.querySelector(`[data-resources-panel][data-panel-index="${panelIndex}"]`);
            if (!targetPanel) return;
            const incomingItems = incomingPanel.querySelectorAll('li');
            const targetList = targetPanel.querySelector('ul');
            if (!targetList || !incomingItems.length) return;
            incomingItems.forEach((item) => {
              targetList.appendChild(item);
            });
          });
        } catch (error) {
          continue;
        }
      }
    };

    loadMorePages();
  });

  } catch(e) { console.error(e); }
})();
})();
